import { readRawCookies } from '@/composables/useCookie';
import { COOKIE_KEY } from '@/constant';
import { defineAppRouteMiddleware } from '@/main';

const ROUTES_NAME_TO_AVOID_WHEN_LOGGING_IN = ['auth', 'forget'];

/**
 * 檢查是否為登入狀態
 */
export default defineAppRouteMiddleware(to => {
  const isAuth = !!readRawCookies()![COOKIE_KEY.TOKEN];

  if (to.meta.auth !== false) {
    if (!isAuth) return '/auth';
  } else {
    if (
      isAuth &&
      ROUTES_NAME_TO_AVOID_WHEN_LOGGING_IN.includes(to.name as string)
    ) {
      return '/';
    }
  }
});
